import React from "react";
import { SettingsPageLayout as Layout } from "Containers/Settings/SettingsHub/SettingsPageLayout";
import { lazyLoader } from "Service/loader";
const UserDashboard = lazyLoader(
  () => import("Containers/User/UserDashboard/UserDashboard")
);

export const UserDashboardPage = () => {
  return (
    <Layout>
      <UserDashboard type="user" />
    </Layout>
  );
};
